import { envTypes } from 'types';

export const config: envTypes.IEnv = {
    apiBaseURL: 'https://api.prashan.shop',
    // apiBaseURL: 'http://127.0.0.1:8000',
    currentPlatform: 'production',
};
